import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliCarat } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ArticoliCaratService extends CrudGenericsService<ArticoliCarat, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliCarat`);
    this.base = `${env.apiUrl}/api/ArticoliCarat/`;
  }

  GetArtCarat_byArt(id: number): Observable<ArticoliCarat[]> {
    const u = `${this.base}GetArtCarat_byArt?id=${id}`;
    return this.http.get<ArticoliCarat[]>(`${u}`);
  }
}
